import styled from 'styled-components';

export const ImageComponent = styled.picture`
  img {
    object-fit: cover;
  }
`;
